import { defineMessages } from 'react-intl';

const addToPlaylistMessages = defineMessages({
    buttonLabel: {
        id: 'add_to_playlist.button.label',
        defaultMessage: 'Add to playlist',
        description:
            'Accessible name of the audio player button that opens the Add to Playlists sheet.',
    },
    tooltipTitle: {
        id: 'add_to_playlist.tooltip.title',
        defaultMessage: 'Playlists are here!',
        description:
            'Title of the one-time tooltip pointing at the audio player Add to playlist button.',
    },
    tooltipBody: {
        id: 'add_to_playlist.tooltip.body',
        defaultMessage: 'Click here to create one now.',
        description:
            'Body of the one-time tooltip pointing at the audio player Add to playlist button.',
    },
    sheetTitle: {
        id: 'add_to_playlist.sheet.title',
        defaultMessage: 'Add to Playlists',
        description:
            'Title of the sheet that adds the playing track to the member’s playlists.',
    },
    sheetCreateNew: {
        id: 'add_to_playlist.sheet.create_new',
        defaultMessage: 'Create New Playlist',
        description:
            'Button in the Add to Playlists sheet that starts creating a playlist.',
    },
    sheetEmptyTitle: {
        id: 'add_to_playlist.sheet.empty.title',
        defaultMessage: 'No Playlists Yet',
        description:
            'Heading in the Add to Playlists sheet when the member has no playlists.',
    },
    sheetEmptyBody: {
        id: 'add_to_playlist.sheet.empty.body',
        defaultMessage: 'Let’s create a playlist here!',
        description:
            'Body in the Add to Playlists sheet when the member has no playlists.',
    },
    sheetPlaylistFull: {
        id: 'add_to_playlist.sheet.playlist_full',
        defaultMessage: 'Playlist full',
        description:
            'Label on a sheet row whose playlist holds the maximum number of tracks.',
    },
    toastAdded: {
        id: 'add_to_playlist.toast.added',
        defaultMessage:
            '{count, plural, one {Track added to playlist} other {Track added to playlists}}',
        description:
            'Toast after saving the sheet when the track was added to {count} playlists.',
    },
    toastRemoved: {
        id: 'add_to_playlist.toast.removed',
        defaultMessage: 'Track deleted',
        description:
            'Toast after saving the sheet when the track was only removed from playlists.',
    },
    alertCountTitle: {
        id: 'add_to_playlist.alert.count.title',
        defaultMessage: 'Playlists are full',
        description:
            'Title of the alert shown when the member already has the maximum number of playlists.',
    },
    alertCountBody: {
        id: 'add_to_playlist.alert.count.body',
        defaultMessage:
            'You’ve reached the maximum number of playlists that can be created.',
        description:
            'Body of the alert shown when the member already has the maximum number of playlists.',
    },
    alertTrackTitle: {
        id: 'add_to_playlist.alert.track.title',
        defaultMessage: 'This playlist is full',
        description:
            'Title of the alert shown when saving would exceed a playlist’s track limit.',
    },
    alertTrackBody: {
        id: 'add_to_playlist.alert.track.body',
        defaultMessage:
            'You’ve reached the track limit. Try removing a track or choosing another playlist to keep adding.',
        description:
            'Body of the alert shown when saving would exceed a playlist’s track limit.',
    },
    alertOk: {
        id: 'add_to_playlist.alert.ok',
        defaultMessage: 'OK',
        description: 'Button that closes a playlist limit alert.',
    },
    unsavedTitle: {
        id: 'add_to_playlist.unsaved.title',
        defaultMessage: 'Track not added',
        description:
            'Title of the confirm shown when the Add to Playlists sheet is closed with unsaved changes.',
    },
    unsavedTitleRemoved: {
        id: 'add_to_playlist.unsaved.title_removed',
        defaultMessage: 'Track not removed',
        description:
            'Title of the confirm shown when the Add to Playlists sheet is closed and its only unsaved changes are removals.',
    },
    unsavedBody: {
        id: 'add_to_playlist.unsaved.body',
        defaultMessage:
            'Would you like to save the update to the playlist(s) before closing?',
        description:
            'Body of the confirm shown when the Add to Playlists sheet is closed with unsaved changes.',
    },
    unsavedDontSave: {
        id: 'add_to_playlist.unsaved.dont_save',
        defaultMessage: 'Don’t Save',
        description:
            'Button in the unsaved changes confirm that closes the sheet without saving.',
    },
});

export default addToPlaylistMessages;
